import { OBJECT_FREEZE_HELPER } from "../../HELPERS/objectFreeze.helper";

/*
    NOTEBOOK - CONEXION API 100% DESDE .ENV
    ------------------------------------------------------------
    Este archivo NO contiene hosts, dominios, puertos ni paths hardcodeados.

    Create React App carga automaticamente:
      npm start      -> .env.development + .env.development.local (si existe)
      npm run build  -> .env.production  + .env.production.local  (si existe)

    Casos recomendados:
      LOCAL       -> .env.development
      NGROK       -> copiar .env.development.local.ngrok.example
                     como .env.development.local
      DEV remoto  -> copiar .env.development.local.dev.example
                     como .env.development.local
      PRODUCTION  -> .env.production
      STAGING     -> copiar .env.production.local.staging.example
                     como .env.production.local antes del build

    IMPORTANTE:
    Todas las variables REACT_APP_* quedan embebidas en el bundle del frontend.
    Nunca guardar passwords, tokens privados ni secretos en estos archivos.
*/

const ENV_VALUE = (name) => {
    const value = process.env[name];
    return typeof value === "string" ? value.trim() : "";
};

const REQUIRED_ENV = (name) => {
    const value = ENV_VALUE(name);
    if (!value) {
        throw new Error(`[NOTEBOOK] Falta la variable de entorno requerida: ${name}`);
    }
    return value;
};

const NORMALIZE_URL = (value) => value.replace(/\/+$/, "");

const BACKEND_MODE = REQUIRED_ENV("REACT_APP_ENVIRONMENT").toUpperCase();
const ALLOWED_MODES = ["LOCAL", "DEV", "NGROK", "STAGING", "PRODUCTION"];

if (!ALLOWED_MODES.includes(BACKEND_MODE)) {
    throw new Error(
        `[NOTEBOOK] REACT_APP_ENVIRONMENT invalido: ${BACKEND_MODE}. `
        + `Valores permitidos: ${ALLOWED_MODES.join(", ")}`,
    );
}

const API_VERSION = REQUIRED_ENV("REACT_APP_API_VERSION");
const API_URL = NORMALIZE_URL(REQUIRED_ENV("REACT_APP_API_URL"));
const SOCKET_URL = NORMALIZE_URL(REQUIRED_ENV("REACT_APP_SOCKET_URL"));
const STATIC_URL = NORMALIZE_URL(REQUIRED_ENV("REACT_APP_STATIC_URL"));

const _SCHEMA = {
    BACKEND_MODE,
    API_VERSION,
    API_URL,
    SOCKET_URL,
    STATIC_URL,
};

export const API_BASE = OBJECT_FREEZE_HELPER.DEEP_FREEZE(_SCHEMA);
